import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { FaWhatsapp } from "react-icons/fa";

export type IndicatorEsfC2CitizensVaccinationsHistoryInfoProps = {
	fullName: string;
	birthdate: string;
	document: string;
	motherName: string;
	phone: string;
	address: string;
};

export function IndicatorEsfC2CitizensVaccinationsHistoryInfo(
	citizenInfo: Readonly<IndicatorEsfC2CitizensVaccinationsHistoryInfoProps>
) {
	return (
		<Row>
			<Col sm={12} md={6} lg={4} xl={4} className="mb-2">
				<span className="fw-bold fs-8 text-primary">Cidadão: </span>
				<span>{citizenInfo.fullName}</span>
			</Col>
			<Col sm={12} md={6} lg={4} xl={4} className="mb-2">
				<span className="fw-bold fs-8 text-primary">Data de nascimento: </span>
				<span>{citizenInfo.birthdate}</span>
			</Col>
			<Col sm={12} md={6} lg={4} xl={4} className="mb-2">
				<span className="fw-bold fs-8 text-primary">Documento: </span>
				<span>{citizenInfo.document}</span>
			</Col>
			<Col sm={12} md={6} lg={4} xl={4} className="mb-2">
				<span className="fw-bold fs-8 text-primary">Nome da mãe: </span>
				<span>{citizenInfo.motherName}</span>
			</Col>
			<Col sm={12} md={6} lg={4} xl={4} className="mb-2">
				<span className="fw-bold fs-8 text-primary">Endereço: </span>
				<span>{citizenInfo.address}</span>
			</Col>
			<Col sm={12} md={6} lg={4} xl={4} className="mb-2">
				<span className="fw-bold fs-8 text-primary">Telefone: </span>
				{citizenInfo.phone}
				<a rel="noreferrer" href={`https://wa.me/55${citizenInfo.phone}`} target="_blank">
					<div title="Contato">
						<FaWhatsapp className="text-success" />
					</div>
				</a>
			</Col>
		</Row>
	);
}
